export default "<app-navigation></app-navigation>\r\n\r\n<router-outlet></router-outlet>\r\n";